<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Secondary Valve Package</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (valveSizeSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Package Size:</label>
            <select class="halfWidthInputField" #secondaryValveSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(valveSizeSelection.Name)"
              (change)="selectionChanged(valveSizeSelection, secondaryValveSizeInput.value)"
              [value]="valveSizeSelection.Value.toString()">
              @for (allowable of valveSizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="valveSizeSelection.Value && valveSizeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (strainerSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Strainer:</label>
            <select class="halfWidthInputField" #secondaryStrainerInput
              [class.invalidConfigurationSelection]="isInvalidSelection(strainerSelection.Name)"
              (change)="selectionChanged(strainerSelection, secondaryStrainerInput.value)"
              [value]="strainerSelection.Value.toString()">
              @for (allowable of strainerSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="strainerSelection.Value && strainerSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (controlValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Control Valve:</label>
            <select class="halfWidthInputField" #secondaryControlValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlValveSelection.Name)"
              (change)="selectionChanged(controlValveSelection, secondaryControlValveInput.value)"
              [value]="controlValveSelection.Value.toString()">
              @for (allowable of controlValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="controlValveSelection.Value && controlValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (flowControlSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Flow Control Type:</label>
            <select class="halfWidthInputField" #secondaryFlowControlInput
              [class.invalidConfigurationSelection]="isInvalidSelection(flowControlSelection.Name)"
              (change)="selectionChanged(flowControlSelection, secondaryFlowControlInput.value)"
              [value]="flowControlSelection.Value.toString()">
              @for (allowable of flowControlSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="flowControlSelection.Value && flowControlSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (isolationBallValveSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Isolation Ball Valve:</label>
            <select class="halfWidthInputField" #secondaryIsolationBallValveInput
              [class.invalidConfigurationSelection]="isInvalidSelection(isolationBallValveSelection.Name)"
              (change)="selectionChanged(isolationBallValveSelection, secondaryIsolationBallValveInput.value)"
              [value]="isolationBallValveSelection.Value.toString()">
              @for (allowable of isolationBallValveSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="isolationBallValveSelection.Value && isolationBallValveSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (balanceOnBypassSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(balanceOnBypassSelection.Name)"
            for="secondaryBalanceOnBypassInput" class="halfWidthInputLabel">Balance on Bypass:</label>
            <input type="checkbox" class="checkboxInput" id="secondaryBalanceOnBypassInput"
              #secondaryBalanceOnBypassInput [checked]="'true' === balanceOnBypassSelection.Value"
              (change)="selectionChanged(balanceOnBypassSelection, secondaryBalanceOnBypassInput.checked.toString())">
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (serviceFittingsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Service Fittings:</label>
            <select class="halfWidthInputField" #secondaryServiceFittingsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(serviceFittingsSelection.Name)"
              (change)="selectionChanged(serviceFittingsSelection, secondaryServiceFittingsInput.value)"
              [value]="serviceFittingsSelection.Value.toString()">
              @for (allowable of serviceFittingsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="serviceFittingsSelection.Value && serviceFittingsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (normallyOpenSelection) {
          <span class="halfWidthConfigurationInput">
            <label [class.invalidConfigurationSelection]="isInvalidSelection(normallyOpenSelection.Name)"
            for="secondaryNormallyOpenInput" class="halfWidthInputLabel">Normally Open:</label>
            <input type="checkbox" class="checkboxInput" id="secondaryNormallyOpenInput"
              #secondaryNormallyOpenInput [checked]="'true' === normallyOpenSelection.Value"
              (change)="selectionChanged(normallyOpenSelection, secondaryNormallyOpenInput.checked.toString())">
          </span>
        }
      </div>
    </div>
  }
</div>
